import React, {useContext, useEffect, useState} from 'react'
import {useHttp} from '../hooks/http.hook'
import {AuthContext} from '../context/AuthContext'
import config from '../config.json'
import {
    getAuthHeader, getLocalStorageItem,
    getPathBack,
    objectLang,
    removeCookieOfFolderId,
    setErrorWindow,
    setLocalStorageItem
} from "../functions"
import {ModalWin} from "../elements/ModalWin"
import {LoaderClass} from "../elements/LoaderClass"
import {PathLineClass} from "../elements/PathLineClass"
import {useNavigate} from "react-router-dom"

export const CreateFolderPage = () => {
    setLocalStorageItem('page', 'CreateFolderPage')
    const $ = require("jquery")

    const {request, loading} = useHttp()
    const auth = useContext(AuthContext)
    const urlParams = new URLSearchParams(window.location.search)
    const folderId = urlParams.get('folderId')
    const lang = objectLang().language
    const l = lang.lang
    const [allowed, setAllowed] = useState(true)
    const [dataModal, setDataModal] = useState({})
    const navigate = useNavigate()

    useEffect(() => {
        window.M.updateTextFields()
    }, [])

    const isGoogleDrive = (folderId.length !== 24) || folderId === 'root'

    const clickHandler = async () => {
        let host
        window.location.host === 'localhost:3000' ? host = config.localHost : host = config.onrender
        let url = isGoogleDrive ? `${host}/api/google-drive/create-folder` : `${host}/api/folder/create`
        if (!$('#name').val()) {
            setAllowed(false)
            setDataModal(setErrorWindow(
                '',
                591,
                '',
                '',
                `replaceTo /${l}/create-folder?folderId=${folderId}`
            ))
            return
        }
        try {
            const data = await request(
                url,
                'POST',
                {
                    parentFID: folderId,
                    userId: auth.userId,
                    redirectURI: window.location.origin,
                    name: document.querySelector('#name').value
                },
                {
                    Authorization: getAuthHeader(auth),
                    'Content-Type': 'application/json'
                })

            if (data.status > 200) {
                setAllowed(false)
                setDataModal(setErrorWindow('', data.code))
            } else {
                removeCookieOfFolderId(folderId)
                if (data['newAccessToken']) auth.accessToken = data['newAccessToken']
                isGoogleDrive ?
                    window.location.replace(`/${l}/google-drive/open/${folderId}`) :
                    window.location.replace(`/${l}/folder/open/${data.folder.parentFID}`)
            }

        } catch (e) {
            window.location.replace(`/${l}/`)
        }
    }

    if (loading) {
        return <LoaderClass />
    }

    if (!allowed) {
        return (
            <>
                <ModalWin data={dataModal}/>
            </>

        )
    }

    return (
        <>
            <PathLineClass documents={getLocalStorageItem('documents')}/>
            <div className={"container d-flex flex-wrap justify-content-center"}>
                <div className={"col-12 col-md-9 mb-3 mt-3"}>
                    <input
                        placeholder={lang.body.createFolderPage.placeholderName}
                        type={"text"}
                        className={"form-control"}
                        id={"name"}
                    />
                </div>
                <button
                    className={"col-4 col-md-3 btn btn-info border-0 me-2"}
                    type={"button"}
                    onClick={() => {
                        navigate(getPathBack(), {replace: true})
                        // window.location.replace(getPathBack())
                    }}>
                    {`${lang.body.general.btnBack}`}
                </button>
                <button
                    className={"col-6 col-md-4 btn btn-success border-0"}
                    type={"button"}
                    onClick={clickHandler}>
                    {lang.body.createFolderPage.btnCreateFolder}
                </button>
            </div>
        </>

    )
}
